import DefaultSignupStrategy from './defaultSignupStrategy';

export default class DefaultTeamSignupStrategy extends DefaultSignupStrategy {
  constructor(props) {
    super(props);

    this.header = 'Sign Up';
    this.headline = 'Sign up now to join your team.';
    this.showCoupon = false;
    this.termsLink = 'https://www.pwrlab.com/team-terms';
    this.privacyLink = 'https://www.pwrlab.com/team-privacy';
  }
}
